import Modal from "react-bootstrap/Modal";
import styles from "./LimitOrDeleteModal.module.css";
import { useTranslation } from "react-i18next";
import { CustomButton } from "../../ReactBootstrap/CustomTabButton";

function RequestReject({ modelData, setModelData, handleRejectConfirm }) {
  const { t } = useTranslation();

  const handleClose = () => {
    setModelData({ show: false, id: "" });
  };

  return (
    <>
      <Modal show={modelData.show} onHide={() => handleClose()}>
        <Modal.Header closeButton style={{ background: "#F5F4F4" }}>
          <Modal.Title>
            <div className={styles.modalHead}>
              <p>
                {t("REJECT")} <span>{t("REQUEST")}</span>
              </p>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={styles.modalBody}>
            <p>{t("REJECT_MEMBERSHIP_REQUEST")}</p>
          </div>
        </Modal.Body>
        <Modal.Footer style={{ background: "#F5F4F4" }}>
          <div className={styles.btnSection}>
            <CustomButton
              variant={"cancelBtn"}
              type="button"
              onClick={() => handleClose()}
            >
              {t("CLOSE")}
            </CustomButton>

            <CustomButton
              variant="activeButton"
              type="button"
              onClick={handleRejectConfirm}
            >
              <p>
                {t("REJECT")} <span> {t("MEMBER_MEM")}</span>
              </p>
            </CustomButton>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default RequestReject;
